import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  addUserBalanceSuccess,
  addUserBalanceFailure,
} from "../../Action/dashboard/addUserBalanceAction";
import { ADD_USER_BALANCE } from "../../Action/actionTypes";
import { notifyPromise } from "../../../Utils/Helper";

function* addUserBalanceRequest(action) {
  try {
    const { data } = yield notifyPromise(
      API.post("/add-user-balance", action?.payload?.payload),
      "Adding balance to user account..."
    );

    if (data?.meta?.code === 200) {
      yield put(addUserBalanceSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(addUserBalanceFailure());
    }
  } catch (error) {
    yield put(addUserBalanceFailure());
  }
}

export function* watchAddUserBalanceAPI() {
  yield takeEvery(ADD_USER_BALANCE, addUserBalanceRequest);
}

export default function* rootSaga() {
  yield all([watchAddUserBalanceAPI()]);
}